// Field configs for each CRUD module.
const YN = ["Yes", "No"];

export const MODULES = {
  leads: {
    title: "Telecalling & Leads",
    fields: [
      { key: "date", label: "Date", type: "date" },
      { key: "lead_name", label: "Lead Name", type: "text", required: true },
      { key: "contact_number", label: "Contact Number", type: "text" },
      { key: "source", label: "Source", type: "select", optionsKey: "sources" },
      { key: "course_interested", label: "Course Interested", type: "select", optionsKey: "courses" },
      { key: "call_status", label: "Call Status", type: "select", options: ["Connected", "Not Reachable", "Call Back Requested", "Not Interested"], badge: true },
      { key: "call_outcome_notes", label: "Call Outcome Notes", type: "textarea", hideInTable: true },
      { key: "counselling_booked", label: "Counselling Booked", type: "select", options: YN, badge: true },
      { key: "assigned_to", label: "Assigned To", type: "select", optionsKey: "telecallers", team: true },
      { key: "next_followup_date", label: "Next Follow-up", type: "date", followup: true },
      { key: "remarks", label: "Remarks", type: "textarea", hideInTable: true },
    ],
  },
  counselling: {
    title: "Counselling & Admissions",
    fields: [
      { key: "date", label: "Date", type: "date" },
      { key: "lead_name", label: "Lead Name", type: "text", required: true },
      { key: "counsellor", label: "Counsellor", type: "select", optionsKey: "counsellors", team: true },
      { key: "course_interested", label: "Course", type: "select", optionsKey: "courses" },
      { key: "counselling_date", label: "Counselling Date", type: "date" },
      { key: "show_up", label: "Show-up", type: "select", options: YN, badge: true },
      { key: "objections", label: "Objections", type: "text" },
      { key: "converted", label: "Converted", type: "select", options: YN, badge: true },
      { key: "admission_fee", label: "Admission Fee", type: "currency" },
      { key: "full_fee", label: "Full Fee", type: "currency" },
      { key: "balance_due", label: "Balance Due", type: "currency", computed: true },
      { key: "remarks", label: "Remarks", type: "textarea", hideInTable: true },
    ],
  },
  bd: {
    title: "Business Development",
    fields: [
      { key: "date", label: "Date", type: "date" },
      { key: "bd_person", label: "BD Person", type: "select", optionsKey: "bd", team: true },
      { key: "partner_name", label: "Partner / Org", type: "text", required: true },
      { key: "partnership_type", label: "Type", type: "select", options: ["Corporate Tie-up", "School-College Outreach", "Referral Partner", "Franchise Enquiry", "Other"] },
      { key: "contact_person", label: "Contact Person", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["Contacted", "In Discussion", "Agreement Signed", "Active"], badge: true },
      { key: "expected_value", label: "Expected Value", type: "currency" },
      { key: "followup_date", label: "Follow-up", type: "date", followup: true },
      { key: "remarks", label: "Remarks", type: "textarea", hideInTable: true },
    ],
  },
  marketing: {
    title: "Marketing",
    fields: [
      { key: "date", label: "Date", type: "date" },
      { key: "channel", label: "Channel", type: "select", optionsKey: "channels" },
      { key: "campaign_name", label: "Campaign", type: "text", required: true },
      { key: "spend", label: "Spend", type: "currency" },
      { key: "leads_generated", label: "Leads", type: "number" },
      { key: "workshop_registrations", label: "Workshop Regs", type: "number", hideInTable: true },
      { key: "website_traffic", label: "Web Traffic", type: "number", hideInTable: true },
      { key: "whatsapp_enquiries", label: "WhatsApp Enq.", type: "number", hideInTable: true },
      { key: "social_followers", label: "Social Followers", type: "number", hideInTable: true },
      { key: "cpl", label: "CPL", type: "currency", computed: true },
    ],
  },
  batches: {
    title: "Batches & Operations",
    fields: [
      { key: "course_name", label: "Course", type: "select", optionsKey: "courses" },
      { key: "batch_name", label: "Batch Name", type: "text", required: true },
      { key: "capacity", label: "Capacity", type: "number" },
      { key: "enrolled", label: "Enrolled", type: "number" },
      { key: "occupancy", label: "Occupancy %", type: "percent", computed: true },
      { key: "batch_start_date", label: "Start Date", type: "date" },
      { key: "faculty_assigned", label: "Faculty", type: "select", optionsKey: "faculty", team: true },
      { key: "material_ready", label: "Material Ready", type: "select", options: YN, badge: true },
      { key: "onboarding_complete", label: "Onboarding", type: "select", options: YN, badge: true, hideInTable: true },
      { key: "feedback_score", label: "Feedback (1-5)", type: "number", hideInTable: true },
      { key: "certificates_issued", label: "Certificates", type: "number", hideInTable: true },
      { key: "status", label: "Status", type: "select", options: ["Upcoming", "Running", "Completed", "Cancelled"], badge: true },
      { key: "remarks", label: "Remarks", type: "textarea", hideInTable: true },
    ],
  },
  finance: {
    title: "Finance",
    fields: [
      { key: "date", label: "Date", type: "date" },
      { key: "revenue", label: "Revenue", type: "currency" },
      { key: "expenses", label: "Expenses", type: "currency" },
      { key: "marketing_spend", label: "Marketing Spend", type: "currency" },
      { key: "profit", label: "Profit", type: "currency", computed: true },
      { key: "outstanding_payments", label: "Outstanding", type: "currency" },
      { key: "refunds", label: "Refunds", type: "currency", hideInTable: true },
      { key: "remarks", label: "Remarks", type: "textarea", hideInTable: true },
    ],
  },
  goals: {
    title: "Goal Setting",
    fields: [
      { key: "goal_name", label: "Goal Name", type: "text", required: true },
      { key: "category", label: "Category", type: "select", options: ["Revenue", "Admissions", "Conversion Rate", "Lead Generation", "Telecalling", "Batch Occupancy", "Marketing", "Business Development"] },
      { key: "metric", label: "Metric It Tracks", type: "text" },
      { key: "target_value", label: "Target Value", type: "number" },
      { key: "time_period", label: "Time Period", type: "select", options: ["Monthly", "Quarterly", "Custom"] },
      { key: "owner", label: "Owner", type: "select", optionsKey: "team", team: true },
      { key: "status", label: "Status", type: "select", options: ["Active", "Achieved", "Missed", "Revised"], badge: true },
      { key: "notes", label: "Notes / Context", type: "textarea", hideInTable: true },
    ],
  },
  team_members: {
    title: "Team Master List",
    fields: [
      { key: "employee_id", label: "Emp ID", type: "text", computed: true },
      { key: "name", label: "Name", type: "text", required: true },
      { key: "email", label: "Google Account Email", type: "text", required: true },
      { key: "function", label: "Function", type: "select", options: ["Telecalling", "Counselling", "Business Development", "Marketing", "Faculty", "Operations"] },
      { key: "courses_assigned", label: "Courses / Batches", type: "text", hideInTable: true },
      { key: "joining_date", label: "Joining Date", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"], badge: true },
      { key: "contact_number", label: "Contact Number", type: "text" },
      { key: "remarks", label: "Remarks", type: "textarea", hideInTable: true },
    ],
  },
};
